// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_u-1";
export var movingGradient = "_u-4";
export var movingGradientBlock = "_u-2";
export var skeleton = "_u-0";
export var skeletonText = "_u-3";